var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', {
    attrs: {
      "aria-haspopup": "true",
      "aria-controls": "menu",
      "id": "accessibility-text-helper-container",
      "tabindex": "0"
    },
    on: {
      "focus": _vm.onFocus,
      "focusout": _vm.onFocusOut,
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.onEscapeKeyUp($event);
      }
    }
  }, [_c('accessibility-text-helper-dropdown')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }